// extracted by mini-css-extract-plugin
export default {"mCard":"mA-z","image":"nA-z","imageNoBackground":"oA-z","imageHasCategory":"pA-z","fullWidth":"qA-z"};